var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArchiveIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  viewBox: "0 0 17 16",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#27333F",
  d: "M15.875 7.804a6.875 6.875 0 1 1-13.75 0 6.875 6.875 0 0 1 13.75 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.625 4.054V7.45l2.822 1.693a.626.626 0 0 1-.644 1.072L8.678 8.34a.63.63 0 0 1-.303-.536v-3.75a.625.625 0 0 1 1.25 0M9 .304a7.46 7.46 0 0 0-5.306 2.2A32 32 0 0 0 2.125 4.21V2.804a.625.625 0 0 0-1.25 0V5.93a.625.625 0 0 0 .625.625h3.125a.625.625 0 0 0 0-1.25H2.828a34 34 0 0 1 1.75-1.92 6.25 6.25 0 1 1 .129 8.965.626.626 0 0 0-.86.91A7.5 7.5 0 1 0 9 .304"
})));
export { SvgArchiveIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/archiveIcon.svg";